export default __webpack_public_path__ + "static/media/img2.690ada89.webp";